import React from 'react'
import { FormGroup, ControlLabel, FormControl, Checkbox, Col } from 'react-bootstrap'

function WaitlistTransactionFields(props) {
  const { selected_program, organization_merch, resetPricingBreakdown } = props
  return (
    <Col sm={12}>
      <FormGroup>
        <ControlLabel className="mobile-title control-lbl">
          <img src="3.png" alt="no. step" className="num-icon"/>&nbsp;
          Select your team apparel
        </ControlLabel>
        <FormGroup className="merch-display">
              {
                selected_program.item_0_cost !== null && organization_merch[0] ?
                  (props.waitlistTransaction.merch.item_0 !== false?
                    (
                    <Checkbox className="checkbox" inline name={"item_0"} id={"item_0"} checked onChange={resetPricingBreakdown} disabled={props.disabled}>
                      <img className="checkbox-img" alt="merch" src={organization_merch[0].logo} /><br/>
                        <div>
                          ${selected_program.item_0_cost}&nbsp;&nbsp;
                        </div>
                        <div>
                          <FormControl className="opaque-grey" name="item_0_size" id="item_0_size" componentClass="select" style={{ width: "45px"}} disabled={props.disabled}>
                            {props.item_0_options}
                          </FormControl>
                        </div>
                    </Checkbox>
                ) : (
                  <Checkbox className="checkbox" inline name={"item_0"} id={"item_0"} onChange={resetPricingBreakdown} disabled={props.disabled}>
                    <img className="checkbox-img" alt="merch" src={organization_merch[0].logo} /><br/>
                      <div>
                        ${selected_program.item_0_cost}&nbsp;&nbsp;
                      </div>
                      <div>
                        <FormControl className="opaque-grey" name="item_0_size" id="item_0_size" componentClass="select" style={{ width: "45px"}} disabled={props.disabled}>
                          {props.item_0_options}
                        </FormControl>
                      </div>
                  </Checkbox>
              )) : ""
              }

              {
                selected_program.item_1_cost !== null && organization_merch[1] ?
                  (props.waitlistTransaction.merch.item_1 !== false ?
                    (
                      <Checkbox className="checkbox" inline name="item_1" id="item_1" checked onChange={resetPricingBreakdown} disabled={props.disabled}>
                        <img className="checkbox-img" alt="merch" src={organization_merch[1].logo} /><br/>
                        <div>
                          ${selected_program.item_1_cost}&nbsp;&nbsp;
                        </div>
                        <div>
                          <FormControl className="opaque-grey formcontrol-width" name="item_1_size" id="item_1_size" componentClass="select" disabled={props.disabled}>
                            {props.item_1_options}
                          </FormControl>
                        </div>
                      </Checkbox>)
                      : 
                      <Checkbox className="checkbox" inline name="item_1" id="item_1" onChange={resetPricingBreakdown} disabled={props.disabled}>
                        <img className="checkbox-img" alt="merch" src={organization_merch[1].logo}/><br/>
                        <div>
                          ${selected_program.item_1_cost}&nbsp;&nbsp;
                        </div>
                        <div>
                          <FormControl className="opaque-grey formcontrol-width" name="item_1_size" id="item_1_size" componentClass="select" disabled={props.disabled} >
                            {props.item_1_options}
                          </FormControl>
                        </div>
                      </Checkbox>) : ""
              }

              {
                selected_program.item_2_cost !== null && organization_merch[2] ? (
                  props.waitlistTransaction.merch.item_2 ?
                    <Checkbox className="checkbox" inline checked name="item_2" id="item_2" onChange={resetPricingBreakdown} disabled={props.disabled}>
                      <img className="checkbox-img" alt="merch" src={organization_merch[2].logo} /><br/>
                      <div>
                        ${selected_program.item_2_cost}&nbsp;&nbsp;
                      </div>
                      <div>
                        <FormControl className="opaque-grey formcontrol-width" name="item_2_size" id="item_2_size" componentClass="select" disabled={props.disabled} >
                          {props.item_2_options}
                        </FormControl>
                      </div>
                    </Checkbox>
              : 
              <Checkbox className="checkbox" inline name="item_2" id="item_2" onChange={resetPricingBreakdown} disabled={props.disabled}>
                <img className="checkbox-img" alt="merch" src={organization_merch[2].logo} /><br/>
                <div>
                  ${selected_program.item_2_cost}&nbsp;&nbsp;
                </div>
                <div>
                  <FormControl className="opaque-grey formcontrol-width" name="item_2_size" id="item_2_size" componentClass="select" disabled={props.disabled} >
                    {props.item_2_options}
                  </FormControl>
                </div>
              </Checkbox>
              ) : ""
            }
        </FormGroup>
      </FormGroup>
    </Col>
  )
}

export default WaitlistTransactionFields
